import type { Product } from '../../productsListing/types'
import type { ProductFilterListItem } from '../types'

export const getProductFilterListData = (
  products: Product[]
): ProductFilterListItem[] => {
  return [
    {
      label: 'All products',
      value: 'allProducts',
      key: 'allProducts',
    },
    ...products.map(product => ({
      label: product.productName,
      value: product.productId,
      key: product.productId,
    })),
  ]
}
